import { Navigate, Route, BrowserRouter as Router, Routes, useNavigate, useParams} from "react-router-dom";
import Signin from "./Components/Account/Signin";
import Signup from "./Components/Account/Signup";
import ForgotPassword from "./Components/Account/ForgotPassword";
import { useEffect, useRef, useState } from "react";
import Investors from "./Components/Header/Investors";
import IntellectualProperty from "./Components/Header/IntellectualProperty";
import PrivacyPolicy from "./Components/Header/PrivacyPolicy";
import UserAgreement from "./Components/Header/UserAgreement";
import OurStory from "./Components/Header/OurStory";
import SurvivorResources from "./Components/Header/SurvivorResources";
import { Hub } from "aws-amplify/utils";

import { Context } from "./Context/Context";
import Cases from "Components/Client/Cases/CasesTable/Cases";
import { CLIENT, ADMIN, PROFESSIONAL, TOKEN, raiseNotificationApi, sendEmailApi, getEmailPrefApi, getUserIdByEmailApi, DOMAIN, reDirectDomain, initialFilterValue, seedArrApi, FIRM, TEAMUP_ENABLED } from "./Constants";
import Layout from "./Components/Account/Layout";
import RequireAuth from "./Components/Account/RequireAuth";
import Unauthorized from "./Components/Account/Unauthorized";
import { HelmetProvider, Helmet } from "react-helmet-async";
import axios from "axios";
import NotificationsPage from "./Components/Client/Notifications/NotificationsPage";
import Profile from "./Components/Profile/Profile";
import AdminPage from "./Components/Admin/AdminPage";
import CreateCase from "Components/Client/Cases/CreateCase/CreateCase";
import CaseDetails from "Components/Client/Cases/CaseDetails/CaseDetails";
// import AdditionalForm from "Components/Client/Cases/CaseDetails/AdditionalForm"; // turned off for now (see AdditionalFormRedirect)
import CasesFeed from "Components/Professional/Cases/CasesFeed";
import ProfNotifications from "Components/Professional/Notifications/ProfNotifications";
import ProfCaseDetails from "Components/Professional/Cases/ProfCaseDetails";
import AdminNotification from "Components/Admin/AdminNotification";
import FirmOutreach from "Components/Admin/Outreach/FirmOutreach";
import ApproveDetailsPage from "Components/Admin/ApproveDetailsPage";
import LoadingGauge from "Components/Icons/LoadingGauge";
import AnalyticsLanding from "Components/Admin/Analytics/AnalyticsLanding";
import AdminCompleteCaseDetails from "Components/Admin/AdminCompleteCaseDetails";
import AdminCasePage from "Components/Admin/AdminCasePage";
import Subscription from "Components/Account/Subscription";
import AdminProfile from "Components/Admin/AdminProfile";
import awsConfig from "./aws_config";

import {Amplify} from "aws-amplify";
import { fetchAuthSession } from "@aws-amplify/auth";
import RootComp from "Components/Header/RootComp";
import ConfirmationPage from "Components/Account/ConfirmationPage";
import ResetPassword from "Components/Account/ResetPassword";
import CompleteProfilePage from "Components/Profile/CompleteProfilePage";
import HomePage from "Components/Header/HomePage";
import HowItWorks from "Components/Header/HowItWorks";
import PricingInfo from "Components/Header/PricingInfo";
import Logo from "Components/Icons/Logo";
import NotFound from "Components/Header/NotFound";

import { configureAutoTrack } from 'aws-amplify/analytics';
import { identifyUser } from "aws-amplify/analytics";
import { getCurrentUser } from "aws-amplify/auth";
import ReactGA from "react-ga4";
import ContactUs from "Components/Header/ContactUs";
import AttorneyDashboard from "Components/Profile/AttorneyDashboard";
import { ToastContainer } from "react-toastify";
import { stateUS } from "states";

ReactGA.initialize("G-D34E3RCK83");
console.log("GA ID", process.env.REACT_APP_GA_PROPERTY_ID);

Amplify.configure(awsConfig);


// Adding more case details after a case is created is turned off for now:
// the old /client/additionalForm/:id address opens the case page instead.
function AdditionalFormRedirect() {
  const { id } = useParams();
  return <Navigate to={"/client/caseDetails/" + id} replace />;
}

function App() {
  const [userDetails, setUserDetails] = useState({});
  const [expiryDate, setExpiryDate] = useState(null);
  const clearFilterRef = useRef(null);
  const [offset, setOffset] = useState(0);
  const [selectedMenuItem, setSelectedMenuItem] = useState(1);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [reqRevCountArr, setReqRevCountArr] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null)

  const [awaitCount, setAwaitCount] = useState({
    firm:0,
    update: 0,
    validUserIdCount:0,
    verify:0
  });

  const [notificationCount, setNotificationCount] = useState(0);
  const [filters, setFilters] = useState(initialFilterValue);
  const [currentPassword, setCurrentPassword] = useState(null);
  const token = localStorage.getItem(TOKEN);
    useEffect(() => {
      const unsubscribe = Hub.listen("auth", ({ payload }) => {
        switch (payload.event) {
          case "signedIn":
            console.log(userDetails?._id);
            console.log("signedIn event",  payload?.data?.userId);
            ReactGA.set({ userId: payload?.data?.userId });
            ReactGA.set({ userIdentification: payload?.data?.user?._id });


          case "signInWithRedirect":
            console.log("signInWithRedirect event", payload.data);
  
            break;
          case "signInWithRedirect_failure":
            console.log("signInWithRedirect event", payload.data);
  
            // setError("An error has occurred during the OAuth flow.");
            break;
          case "customOAuthState":
            console.log("signInWithRedirect event", payload.data);
            // setCustomState(payload.data); // this is the customState provided on signInWithRedirect function
            break;
            default:
              break;
        }
      });
     
  
      return unsubscribe;
      
    }, []);
  const [states, setStates] = useState(stateUS);
  const [updateLoggedinData, setUpdateLoggedinData] = useState(false);    
  const [showLoading, setShowLoading] = useState(false)
  function isUserEligible (data, notificationCategory)
  {
    console.log(data.type, notificationCategory);
    switch(notificationCategory)
    {
      case 0:
        return data?.type === 0; //account type emails will be sent if emailpref type is 0
      case 1:
        return data?.triggerType === 0; //case type emails will be sent if triggerType is 0
      default:
        return false;
    }
  
  }
  function getForwardLink(role)
  {
    if(role === CLIENT)
    {
      return reDirectDomain + "/client/cases";
    }
    else if(role === PROFESSIONAL)
    {
      return reDirectDomain + "/attorney/casesFeed/availableCases";
    }
    else if(role === ADMIN)
    {
      return reDirectDomain + "/admin/approve";
    }
  }
  async function sendEmailNotifications(postData, successCallback = () => {}) 
  {
      makeApiCallFunc(getEmailPrefApi,
        {id : postData?.receiver},
        ({data}) =>
        {
          if(isUserEligible(data, postData?.notificationCategory))
          {
            makeApiCallFunc(sendEmailApi, {
              "recipientEmail" :data?.user?.email,
              "subject" : postData?.title,
              "title" : postData?.title || "New notification in your account",
              "content" : postData?.content,
            },
              successCallback,
              (data) => console.log(data)
              )
          }
          else
          {
            console.log("user not eligible for email");
          }
      },
      ({data}) => console.log(data),
      null,
      true
      )
  }
  function getAuthorizationHeader () 
  {
    try {
       return fetchAuthSession().then((session) => {
          const accessToken = session.tokens.accessToken.toString();
          return "Bearer " + accessToken;
          }
          ).catch((error) => {
              console.log("getAuthorizationHeader error", error);
              window.location.href = "/signin";
              return null;
          }
      );
    } catch (error) {
      console.log("getAuthorizationHeader error", error);
      window.location.href = "/signin";
      console.log(error);
      return null;
    } 
  }
  async function makeApiCallFunc (apiCall, postData, successCallback, errorCallback, addMultipart, showNoLoadingGauge = false, noAuthToken = false)
  {
    const token = noAuthToken ? null : await getAuthorizationHeader();
    if(!showNoLoadingGauge)
    {
      setShowLoading(true);
    }
    let config = {
      method: 'get',
      url: apiCall,
      headers: {
          Authorization : token,
          "Content-Type" : addMultipart ? "multipart/form-data" : "application/json"
      },
    };
    if(postData)
    {
      config = {...config, method : 'post', data: postData}
      console.log("first");
      console.log(config)
    }
    try {
      const data = await axios(config)
      if(data) 
      {
        if(apiCall === raiseNotificationApi)
        {
          if(postData.receiver && postData?.doNotSendEmail !== true)
          {
             sendEmailNotifications(postData, successCallback);
          }
        }
        if(!showNoLoadingGauge)
        {
         setShowLoading(false);
        }
         successCallback(data);
      }
      else {
        if(!showNoLoadingGauge)
        {
         setShowLoading(false);
        }
        errorCallback ? errorCallback(null) : console.log("error in api call");
      }
    } 
    catch (error) 
    {
      if(!showNoLoadingGauge)
      {
      setShowLoading(false);
      }
      errorCallback ? errorCallback(error) : console.log("error in api call", error);

    }
    
}
function addCases ()
{
  makeApiCallFunc(seedArrApi, null, (data) => console.log(data), (data) => console.log(data))
}
  return (
    <>
      <Context.Provider value={{
        notificationCount, 
        setNotificationCount, 
        setReqRevCountArr,
        reqRevCountArr,
        userDetails, 
        setUserDetails, 
        states, 
        updateLoggedinData, 
        setUpdateLoggedinData, 
        filters, setFilters,
        clearFilterRef,
        isFilterApplied, setIsFilterApplied,
        showLoading, 
        setShowLoading, 
        offset,
        setOffset,
        makeApiCallFunc,
        selectedMenuItem, 
        setAwaitCount,
        awaitCount,
        selectedOption,
        setSelectedOption,
        setSelectedMenuItem
        }}>
          
          <HelmetProvider>
            <Helmet>
              <title>
                
              Quick Case Review
              </title>
            </Helmet>
            <div>
            <div className="App relative w-full h-full ">
            
            
              {
                showLoading &&
                <LoadingGauge mask={true}/>
              }
            <Router>
                <Routes>
                      <Route path="forgotpassword" element={<ForgotPassword/>}/>
                      <Route path="/investors" element={<Investors />} />
                      <Route path="/intellectual-property" element={<IntellectualProperty />} />
                      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                      <Route path="/user-agreement" element={<UserAgreement />} />
                      <Route path="/our-story" element={<OurStory />} />
                      <Route path="/survivor-resources" element={<SurvivorResources />} />
                      <Route path="/" element={<HomePage/>}/>
                      <Route path = "/howItWorks/:role" element = {<HowItWorks/>} />
                      <Route path="/contact-us" element={<ContactUs />} />
                      <Route path = "/pricing" element = {<PricingInfo/>}/>
                      <Route path="unauthorized" element={<Unauthorized />} />
                      <Route path="/confirm" element={<ConfirmationPage currentPassword={currentPassword}/>}/>
                      
                     <Route element={<RootComp rootComp={1} />}>
                        <Route path="signup" element={<Signup setCurrentPassword={setCurrentPassword}/>}/> 
                        <Route path="signup/:role" element={<Signup setCurrentPassword={setCurrentPassword}/>}/> 
                    </Route>
                    <Route element={<RootComp/>}>
                        <Route path="signin" element={<Signin expiryDate={expiryDate} setExpiryDate={setExpiryDate}/>}/>
                        <Route path="signin/:role" element={<Signin expiryDate={expiryDate} setExpiryDate={setExpiryDate}/>}/>
                        <Route path="resetPassword" element={<ResetPassword/>}/>
                    </Route> 
                    <Route element={<Layout/>}>
                      <Route element = {<RequireAuth allowedRole={[CLIENT]}/>}>
                          <Route exact path="/client/profile" element={<Profile/>}/>
                          <Route exact path="/client/profile/:setPanel" element={<Profile/>}/>
                          <Route path="/client/cases" element={<Cases/>}/>
                          <Route path="/client/notification" element={<NotificationsPage/>}/>
                          <Route path="/client/createCase" element={<CreateCase/>}/>
                          <Route path="/client/caseDetails/:id" element = {<CaseDetails/>} />
                          <Route path="/client/additionalForm/:id" element = {<AdditionalFormRedirect/>} />
                          </Route>
                          <Route element = {<RequireAuth allowedRole={[PROFESSIONAL, FIRM]}/>}>
                          <Route exact path="/attorney/profile" element={<Profile/>}/>
                          <Route exact path="/attorney/profileCompletion" element={<CompleteProfilePage/>}/>
                          <Route exact path="/attorney/profile/:setPanel" element={<Profile/>}/>
                          <Route exact path="/attorney/casesFeed" element={<Navigate to="/attorney/casesFeed/availableCases" replace/>}/>
                          <Route exact path="/attorney/casesFeed/:setPanel" element={<CasesFeed/>}/>
                          <Route exact path="/attorney/dashboard" element={TEAMUP_ENABLED ? <AttorneyDashboard/> : <Navigate to="/attorney/casesFeed/availableCases" replace/>}/>
                          <Route path="/attorney/notification" element={<ProfNotifications/>} />
                          <Route path="/attorney/caseDetails/:id" element = {<ProfCaseDetails/>} />
                          <Route path="/attorney/subscription" element = {<Subscription/>} />
                      </Route>
                      <Route element= {<RequireAuth allowedRole={[ADMIN]}/>}>
                        <Route path="/admin/approve" element={<AdminPage/>}/>
                        <Route path="/admin/profile" element={<AdminProfile/>}/>
                        <Route path="/admin/notification" element={<AdminNotification/>}/>
                        <Route path="/admin/analytics" element={<AnalyticsLanding/>}/>
                        <Route path="/admin/outreach" element={<FirmOutreach/>}/>
                        <Route path="/admin/caseDetails/:id" element = {<AdminCasePage/>} />
                      </Route>
                    </Route>
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Router>
          </div>
        </div>
        </HelmetProvider>
      </Context.Provider>
       <ToastContainer
        position="top-right"
        autoClose={3000}
        pauseOnHover
        newestOnTop
      />
      </>
  );
}

export default App;
